import api from '../utils/api';

export async function listAgents({ page = 1, perPage = 20, search = null } = {}) {
  const params = { page, per_page: perPage };
  if (search) {
    params.search = search;
  }
  const { data } = await api.get('/agents/', { params });
  return data;
}

export async function getAgent(id) {
  const { data } = await api.get(`/agents/${id}`);
  return data;
}

export async function createAgent(payload) {
  const { data } = await api.post('/agents/', payload);
  return data;
}

export async function updateAgent(id, payload) {
  const { data } = await api.put(`/agents/${id}`, payload);
  return data;
}

export async function deleteAgent(id) {
  const { data } = await api.delete(`/agents/${id}`);
  return data;
}
